import { LabelField } from '@/components';
import { AdvertDestinationLabel, Experience } from '@/types';
import { Stack } from '@silverstein-properties/inspirelabs-ui';

export type AdvertDestinationSectionPropsType = {
  experience: Experience;
};

export const AdvertDestinationSection = ({
  experience,
}: AdvertDestinationSectionPropsType) => {
  return (
    <Stack spacing={4} data-testid="advertDestination">
      <LabelField
        label="Where should the promotion lead?"
        value={
          AdvertDestinationLabel[
            experience.advertDestination as keyof typeof AdvertDestinationLabel
          ]
        }
      />
    </Stack>
  );
};
